import { FormControl, InputLabel, Select } from "@mui/material";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let id = 1;
export function Select3(props) { const [labelId] = useState(() => "select-label-" + id++); return /*#__PURE__*/ _jsxs(FormControl, { fullWidth: props.fullWidth, children: [/*#__PURE__*/ _jsx(InputLabel, { id: labelId, children: props.label }), /*#__PURE__*/ _jsx(Select, Object.assign({}, props))] }); }
